import React, { useState } from 'react';
import PageTitle from '../common/page.title';
import QuickLinkGallery from './quick-link/quick-link-gallery';
import TempMessageContainer from './temp-message/temp-message-container';
import WishListGallery from './wish-list/wish-list-gallery';
import TransferPatientAlert from '../common/transfer-patient-alert';
import HelpCenterFeature from '../my-account/help-center/help-center-feature';
import FeaturedAvailabilityTabs from './featured-availability-tabs/featured-availability-tabs';
import { usePiTracker } from '../../hooks/pi-tracker';
import BenefitsDropdown from '../common/benefits-dropdown';

const Index: React.FC = () => {
    usePiTracker();
    const [selectedAgreement, setSelectedAgreement] = useState('');
    const handleAgreementChange = (e: any) => {
        const agreement = e.target.value as string;
        setSelectedAgreement(agreement);
    };

    return (
        <>
            <TransferPatientAlert />
            <PageTitle pageTitleId="ESTORE_UPPER" />
            <div
                id={
                    localStorage.getItem('MiracleEar')
                        ? 'MiracleEar'
                        : undefined
                }
            >
                <FeaturedAvailabilityTabs />
                <QuickLinkGallery />
                {!localStorage.getItem('MiracleEar') && <HelpCenterFeature />}
                <BenefitsDropdown
                    selectedAgreement={selectedAgreement}
                    handleChange={handleAgreementChange}
                    needsWishes={true}
                />
                <WishListGallery selectedAgreement={selectedAgreement} />
            </div>
            <TempMessageContainer />
        </>
    );
};

export default Index;
